import React from 'react'
import { CircularProgress, Box, Typography } from '@mui/material'

const EntitlementCircularProgress = ({ balance, total, ...rest }) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        color="gray-background"
        size={115}
        sx={{
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }}
        {...rest}
      />
      <CircularProgress
        variant="determinate"
        value={((total - balance) / total) * 100}
        color="alternate"
        size={115}
        sx={{
          position: 'absolute',
          left: 0,
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }}
        {...rest}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h4" color="alternate.main" sx={{ fontWeight: 'bold' }}>
          {Number(balance).toFixed(1)}
        </Typography>
        <Typography variant="body2" color="alternate.main">
          days left
        </Typography>
      </Box>
    </Box>
  )
}

export default EntitlementCircularProgress
